/** Page size for gallery "Load more" reads. */
export const GALLERY_PAGE_SIZE = 24;

/**
 * Offset of the next page, or `undefined` when the source is exhausted. Uses
 * the server `total` when the endpoint returns one; otherwise a short page
 * means there is nothing left.
 */
export const getNextOffset = (
  lastPage: { items: unknown[]; offset?: number; total?: number },
  allPages: { items: unknown[] }[],
  pageSize: number
): number | undefined => {
  const loaded = allPages.reduce((count, page) => count + page.items.length, 0);
  if (lastPage.total !== undefined) {
    return loaded < lastPage.total ? loaded : undefined;
  }
  return lastPage.items.length < pageSize ? undefined : loaded;
};
